import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Shield, Lock } from 'lucide-react';

export default function AdminPortal() {
  const navigate = useNavigate();

  const handleAdminLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <Card className="bg-zinc-900/50 border-[#F9004D]/50 p-12 max-w-md w-full">
        <div className="text-center space-y-6">
          <div className="h-20 w-20 bg-[#F9004D]/20 rounded-full flex items-center justify-center mx-auto">
            <Shield className="h-10 w-10 text-[#F9004D]" />
          </div>
          
          <h1 
            className="text-3xl font-bold text-white"
            style={{ fontFamily: 'Syne, sans-serif' }}
          >
            Admin Portal
          </h1>
          
          <p className="text-zinc-400">
            <Lock className="h-4 w-4 inline mr-2" />
            Accès réservé aux administrateurs
          </p>

          <Button
            onClick={handleAdminLogin}
            className="w-full bg-[#F9004D] hover:bg-[#D00040] text-white rounded-full py-6 text-lg font-bold"
            data-testid="admin-login-button"
          >
            Connexion Admin
          </Button>

          <button
            onClick={() => navigate('/')}
            className="text-zinc-500 hover:text-zinc-400 text-sm"
          >
            ← Retour à l'accueil
          </button>
        </div>
      </Card>
    </div>
  );
}